import React from "react";

import {
    DEPENDENCY_COVERAGE_HEADER,
    DEPENDENCY_COVERAGE_MESSAGE,
} from "src/web/constants";

export const DependencyCoverageSection: React.FC = () => (
    <>
        <h4>{DEPENDENCY_COVERAGE_HEADER}</h4>
        <p>{DEPENDENCY_COVERAGE_MESSAGE}</p>
    </>
);

export default DependencyCoverageSection;
